exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#watermetersRegisterModal .v--modal-box.v--modal{min-height:440px!important;min-width:620px!important}#watermetersRegisterModal .modal__footer{display:none}#watermetersRegisterModal .modal__content{margin-top:-50px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5b931c69","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/viewer/watermeters/modals/WatermetersRegister.vue
// module id = 1739
// module chunks = 0